import { getDeviceId } from "./DeviceId"
import { HttpError } from "../api/ApiClient"

const API_PREFIX = "/wp-json/edu/v6"

export interface AuthResponse {
  access_token: string
  refresh_token: string
  expires_in: number
}

export interface MeResponse {
  user_id: number
}

export class AuthAPI {
  private readonly baseUrl: string

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl
  }

  private async request<T>(
      path: string,
      options: RequestInit
      ): Promise<T> {
      const response = await fetch(
        `${this.baseUrl}${API_PREFIX}${path}`,
        {
          ...options,
          headers: {
            "Accept": "application/json",
            ...(options.headers ?? {})
          }
        }
      )

      if (!response.ok) {
        let code: string | undefined

        try {
          const data = await response.json()
          code = data?.code
        } catch {
          // ignore
        }

        throw new HttpError(response.status, code)
      }

      return response.json()
   }



  async login(email: string, password: string): Promise<AuthResponse> {
    return this.request<AuthResponse>("/auth/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email,
        password,
        device_id: getDeviceId()
      })
    })
  }

  async refresh(refreshToken: string): Promise<AuthResponse> {
    return this.request<AuthResponse>("/auth/refresh", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        refresh_token: refreshToken,
        device_id: getDeviceId()
      })
    })
  }



  async logout(
    accessToken: string,
    refreshToken: string
  ): Promise<void> {
    await this.request("/auth/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      body: JSON.stringify({
        refresh_token: refreshToken
      })
    })
  }

  async me(accessToken: string): Promise<MeResponse> {
    return this.request<MeResponse>("/auth/me", {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${accessToken}`
      }
    })
  }

  async requestOtp(
      email: string,
      referral: string | null = null
  ): Promise<void> {

      await this.request("/auth/otp/request", {
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },

              body: JSON.stringify({
              email,
              referral
          })
      })
  }

  async confirmOtp(
        email: string,
        otp: string
        ): Promise<AuthResponse> {
        return this.request<AuthResponse>("/auth/otp/confirm", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            email,
            otp,
            device_id: getDeviceId()
          })
        })
      }
}